<template>
  <div class="back-button">
    <router-link v-if="route" :to="route" class="link">
      « <span v-if="text">{{ text }}</span
      ><span v-else>Back</span>
    </router-link>
    <a v-else class="link" @click="$router.go(-1)">
      « <span v-if="text">{{ text }}</span
      ><span v-else>Back</span></a
    >
  </div>
</template>

<script>
export default {
  props: {
    route: { type: [String, Object], default: '' },
    text: { type: String, default: '' },
  },
}
</script>

<style scoped>
.back-button {
  margin-bottom: 0.4em;
}

.link {
  color: var(--color-tertiary) !important;
  text-decoration: underline;
}
</style>
